import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=bd45d468&scoped=true&"
import script from "./Index.vue?vue&type=script&lang=js&"
export * from "./Index.vue?vue&type=script&lang=js&"
import style0 from "./Index.vue?vue&type=style&index=0&id=bd45d468&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd45d468",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bd45d468')) {
      api.createRecord('bd45d468', component.options)
    } else {
      api.reload('bd45d468', component.options)
    }
    module.hot.accept("./Index.vue?vue&type=template&id=bd45d468&scoped=true&", function () {
      api.rerender('bd45d468', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/prize/status/Index.vue"
export default component.exports